import axios from "axios";

export default axios.create({
  baseURL: "https://api.stats.voicehub.astroline.com:4002",
  headers: {
    "Content-type": "application/json",
    Authorization: "Basic ci5sb3BlekBhc3Ryb2xpbmUuY29tOjEyMzQ=",
  },
});
